import v2_7_0 from './releasenotes/2_7_0.html';
import v2_7_5 from './releasenotes/2_7_5.html';
import v2_8_59 from './releasenotes/2_8_59.html'

export const ReleaseNotes: {[key: string]: string} = {
    "2.7.0": v2_7_0,
    "2.7.5": v2_7_5,
    "2.7.59": v2_8_59
}